import {ChevronRightIcon} from '@primer/octicons-react'
import {IconButton, ProgressBar} from '@primer/react'
import styles from './MiniMergeSections.module.css'
import {MiniStatusIcon, type MiniStatusIconProps} from './MiniStatusIcon'

import {
  isSuccessStatus,
  type CombinedState,
  type StatusRollup,
} from '@github-ui/mergebox/page-data/payloads/status-checks'
import {useGoToMergeBox} from '../../../mergebox/use-go-to-mergebox'

export type ChecksMiniStatusProps = {
  statusRollup: StatusRollup
}

const iconTypeByCombinedState: Record<CombinedState, MiniStatusIconProps['type']> = {
  PASSED: 'success',
  PENDING: 'warning',
  PENDING_APPROVAL: 'warning',
  PENDING_CONFLICTS: 'warning',
  FAILED: 'failure',
  PENDING_FAILED: 'failure',
  SOME_FAILED: 'failure',
}

export function ChecksMiniStatus({statusRollup}: ChecksMiniStatusProps) {
  const goToMergeBox = useGoToMergeBox()

  if (statusRollup.summary.length === 0) {
    return null
  }

  let successfulChecks = 0
  let totalChecks = 0

  for (const summary of statusRollup.summary) {
    totalChecks += summary.count

    if (isSuccessStatus(summary.state)) {
      successfulChecks += summary.count
    }
  }

  return (
    <section className={styles.MiniStatus} aria-label="Checks">
      <div className={styles.MiniStatusLabelRow}>
        <span className="d-flex flex-items-center gap-1">
          <MiniStatusIcon type={iconTypeByCombinedState[statusRollup.combinedState] ?? 'warning'} />
          <strong>Checks</strong>{' '}
          <span className="fgColor-muted">
            {successfulChecks}/{totalChecks}
          </span>
        </span>

        <IconButton
          aria-label="View checks"
          icon={ChevronRightIcon}
          // TODO: Update the panel to open the checks section in the merge status panel. The current open panel options
          // don't support expanding sections within the merge status panel
          onClick={event => goToMergeBox(event.currentTarget)}
          size="small"
          variant="invisible"
        />
      </div>
      <ProgressBar
        aria-label={`${successfulChecks} of ${totalChecks} successful checks`}
        className={styles.MiniStatusProgress}
        progress={(successfulChecks / totalChecks) * 100}
      />
    </section>
  )
}
